module.exports = __webpack_public_path__ + "img/16.0d991c07.jpg";